import LoyaltyTierLabel from 'components/Common/Labels/LoyaltyTierLabel'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import type { ReactElement } from 'react'
import { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import ModalContext from 'contexts/ModalContext'
import LandingPageLoyaltyLoungePassBenefitsModal from './LandingPageLoyaltyLoungePassBenefitsModal'

const image: App.Image = {
  id: 'rq13k5lzgr8oxoz3a2',
  title: 'Free airport lounge passes',
}

interface Props {
  tier: App.LoyaltyTier
  benefitLabel: ReactElement
}

function LandingPageLoyaltyLoungePass(props: Props) {
  const { tier, benefitLabel } = props
  const showModal = useContext(ModalContext)
  const intl = useIntl()

  const handleDetailsClick = useCallback(() => {
    showModal(<LandingPageLoyaltyLoungePassBenefitsModal
      image={image}
    />)
  }, [showModal])

  return <LandingPageLoyaltyBenefitTile
    heading={intl.formatMessage({
      id: 'c9p-4SjsKWKqzrAh-aoA',
      defaultMessage: 'Free airport lounge passes',
      description: 'Heading for loyalty airport lounge pass benefit tile',
    })}
    labels={<LoyaltyTierLabel kind="primary" tier={tier}>{benefitLabel}</LoyaltyTierLabel>}
    image={image}
    actions={<TextButton kind="secondary" onClick={handleDetailsClick}>
      {intl.formatMessage({
        id: 'OeFquzYl5aVyjovyZN0W',
        defaultMessage: 'Details',
        description: 'Link to open lounge pass benefit details modal on the promotional landing page',
      })}
    </TextButton>}
  >
    <BodyText variant="medium">
      {intl.formatMessage({
        id: 'LjLE26Cgfe6gep7CuZSD',
        defaultMessage: 'Kick off your trip in comfort with complimentary access to select airport lounges. Recharge with a drink, a bite to eat, and space to relax before your international flight. Simply add to your booking when checking out for your overseas escapes.',
        description: 'Description of the complimentary airport lounge pass loyalty benefit',
      })}
    </BodyText>
  </LandingPageLoyaltyBenefitTile>
}

export default LandingPageLoyaltyLoungePass
